module.exports = __webpack_public_path__ + "img/4.32f03014.png";